<template>
  <div class="footer">
    <!-- Footer-->
    <div class="social-media">
      <a href="https://instagram.com/yeypass">Instagram</a>
      <a href="https://twitter.com/getyeypass">Twitter</a>
      <a href="https://facebook.com/yeypass">Facebook</a>
    </div>
    <div class="copyright">&copy; {{ date }} <a href="/">YeyPass</a></div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'footer-view',
  data() {
    return {
      date: moment().year()
    }
  }
}
</script>

<style scoped>
.footer {
  padding: 20px 24px 24px 24px;
  height: 60px;
  font-family: "HKGrotesk-Medium", Helvetica, sans-serif;
}

.footer .copyright{
  padding-left: 24px;
  font-size: 16px;
  float: left;
  color: #0C275B;
}

.footer .social-media{
  float: right;
}

.footer a {
  padding-right: 24px;
  font-size: 16px;
  color: #00386A;
  float: right;
}

@media only screen and (max-width: 480px) {
  .footer .copyright{
    padding: 0;
  }

  .footer{
    height: auto;
    padding: 12px;
  }

  .footer a{
    display: inline-block;
    float: none;
    padding-right: 0;
    margin: 0 10px;

  }

  .footer .copyright, .footer .social-media{
    display: block;
    float: none;
    clear: both;
    margin: 0 auto;
    text-align: center;
  }

  .footer .copyright{
    margin-top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue